(function(){
  'use strict';

  window.Coop = window.Coop || { Modules: {} };

  Coop.Modules.Geolocator = {
    defaults: {
      searchFormSelector: '.finder-form',
      locationButtonSelector: '[data-geolocator-locate]',
      addressInputSelector: '[data-geolocator-address]',
      googleAPIKey: window.GOOGLE_API_KEY,
      validAddressTypes: [
        'locality',
        'sublocality',
        'street_address',
        'route',
        'postal_code',
        'colloquial_area',
        'neighborhood',
        'park',
        'administrative_area_level_1',
        'administrative_area_level_2',
        'administrative_area_level_3'
      ],
      invalidAddresses: [
        'England, UK',
        'Scotland, UK',
        'Wales, UK',
        'Northern Ireland, UK'
      ],
      validLocalityTypes: [
        'locality',
        'sublocality',
        'neighborhood',
        'postal_town',
        'postal_code_prefix'
      ]
    },
    errorMessages: {
      addressNotFound: 'Sorry, we cannot find this address',
      noBranchesFound: 'We cannot find any funeral homes near this location',
      locationNotFound: 'Unable to find your location'
    },
    triggerIds: {
      processingDone: 'processingDone',
      locationDone: 'getLocationDone',
      locationStart: 'getLocationStart'
    },
    init: function() {
      this.$searchForm = $(this.defaults.searchFormSelector);
      this.$locationButton = $(this.defaults.locationButtonSelector);
      this.$addressInput = $(this.defaults.addressInputSelector);

      this.currentLocation = null;
      this.autoComplete = null;
      this.geocoder = null;

      // browser geolocation support
      this.geolocationSupport = this.testGeolocationSupport();
      if (this.geolocationSupport) {
        this.geocoder = new google.maps.Geocoder();
        this.bindUseLocationEvent();
        this.bindStatusEvent();
      }
      else {
        $('html').addClass('no-geolocation');
      }

      // Google Maps support
      this.googleSupport = this.testGoogleSupport();
      if (this.googleSupport && this.$addressInput.length) {
        if (!this.geocoder) {
          this.geocoder = new google.maps.Geocoder();
        }
      }
    },
    testGeolocationSupport: function() {
      return 'geolocation' in navigator;
    },
    testGoogleSupport: function() {
      return typeof window.google !== 'undefined';
    },
    bindStatusEvent: function() {
      var self = this;

      this.$searchForm
        .off(this.triggerIds.locationStart)
        .on(this.triggerIds.locationStart, function() {
          self.$searchForm.addClass('loading');
          self.$locationButton.addClass('btn-loading');
        })
        .off(this.triggerIds.locationDone)
        .on(this.triggerIds.locationDone, function() {
          self.$searchForm.removeClass('loading');
          self.$locationButton.removeClass('btn-loading');
        });
    },
    bindUseLocationEvent: function() {
      var self = this;

      this.$locationButton.on('click', function() {
        self.browserLocation(function(coords) {
          self.useLocation(coords);
        });
      });
    },
    useLocation: function(coords) {
      var self = this;

      this.addressFromCoordinates(coords.latitude, coords.longitude, function(location_data) {
        self.$searchForm.trigger(self.triggerIds.locationDone);
        self.$addressInput.val(location_data.formatted_address).trigger('change');

        if (typeof locationSearch !== 'undefined') {
          location_data.latitude = coords.latitude;
          location_data.longitude = coords.longitude;
          locationSearch.addToSearchHistory(location_data.formatted_address, location_data);
        }
      });
    },
    isValidAddress: function(result) {
      if (typeof result.types === 'undefined' || !result.types.length) {
        return false;
      }

      for (var i = 0; i < result.types.length; i++) {
        if (this.defaults.validAddressTypes.indexOf(result.types[i]) !== -1) {
          return this.defaults.invalidAddresses.indexOf(result.formatted_address) === -1;
        }
      }

      return false;
    },
    getLocality: function(result) {
      var components = result.address_components,
          component;

      if (typeof components === 'undefined' || !components.length) {
        return 'search';
      }

      for (var i = 0; i < components.length; i++) {
        component = components[i];

        for (var j = 0; j < component.types.length; j++) {
          if (this.defaults.validLocalityTypes.indexOf(component.types[j]) !== -1) {
            return component.long_name;
          }
        }
      }

      return 'search';
    },
    geocoderHandler: function(results, status, callback) {
      if (status === 'OK') {
        if (this.isValidAddress(results[0])) {
          var location_data = {
            latitude: results[0].geometry.location.lat(),
            longitude: results[0].geometry.location.lng(),
            locality: this.getLocality(results[0])
          };

          callback(location_data);
        } else {
          Coop.Modules.LocationSearch.addBasicErrorMessage(this.errorMessages.noBranchesFound);
          this.$searchForm.trigger(this.triggerIds.processingDone);
        }
      } else {
        Coop.Modules.LocationSearch.addBasicErrorMessage(this.errorMessages.addressNotFound);
        this.$searchForm.trigger(this.triggerIds.processingDone);
      }
    },
    coordinatesFromAddress: function(address, callback) {
      var self = this,
          southwest = new google.maps.LatLng(48, -10),
          northeast = new google.maps.LatLng(61, 3),
          bounds = new google.maps.LatLngBounds(southwest, northeast);

      this.geocoder.geocode({address: address, bounds: bounds, componentRestrictions: {
        country: 'GB'
      }}, function(results, status) {
        self.geocoderHandler(results, status, callback);
      });
    },
    reverseGeocoderHandler: function(results, status, callback) {
      if (status === 'OK') {
        var location_data = {
          formatted_address: results[0].formatted_address,
          locality: this.getLocality(results[0])
        };

        callback(location_data);
      } else {
        Coop.Modules.LocationSearch.addBasicErrorMessage(this.errorMessages.locationNotFound);
        this.$searchForm.trigger(this.triggerIds.locationDone);
      }
    },
    addressFromCoordinates: function(latitude, longitude, callback) {
      var self = this;

      this.geocoder.geocode({location: {lat: latitude, lng: longitude}}, function(results, status) {
        self.reverseGeocoderHandler(results, status, callback);
      });
    },
    browserLocation: function(callback) {
      var self = this;

      if (this.geolocationSupport) {
        this.$searchForm.trigger(self.triggerIds.locationStart);

        navigator.geolocation.getCurrentPosition(function(position) {
          var coords = {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude
          };
          self.currentLocation = coords.latitude + ',' + coords.longitude;
          callback(coords);
        },
        function(error) {
          Coop.Modules.LocationSearch.addBasicErrorMessage(self.errorMessages.locationNotFound);
          self.$searchForm.trigger(self.triggerIds.locationDone);
        });
      }
    }
  };
})();
